import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { API_BASE_URL } from './backoffice';

// UI language packages moved to the separate "I18n" Swagger document
// (/api/i18n/{appCode}/{locale}/generate). The old /api/v1/i18n route in
// backoffice.ts now returns 404. Same response shape as the generated client,
// so the loader can switch back to an NSwag-generated client at any time.
@Injectable({ providedIn: 'root' })
export class I18nPackClient {
  constructor(private readonly http: HttpClient, @Inject(API_BASE_URL) private readonly baseUrl: string) { }

  getGenerate(appCode: string, locale: string): Observable<{ result: { data: Blob } }> {
    const url = `${this.baseUrl.replace(/\/$/, '')}/api/i18n/${encodeURIComponent(appCode)}/${encodeURIComponent(locale)}/generate`;
    return this.http.get(url, { responseType: 'blob' }).pipe(map(data => ({ result: { data } })));
  }
}
